module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/rachel_b4c4bf.png";